// Description: Header that will have functionalities like close or change step
// Updated: 11/04/2025
// Author: Simon Franklin

// React
import React from 'react';

// Material UI Components
import { Box } from '@mui/material';
import { ArrowBackIosNew, CloseOutlined } from '@mui/icons-material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

// Components and Functions for the project
import themeColors from '../ThemeColors/ThemeColors';

// Render The Component
const ModeGraphicModalHeader = ({ setShowNewTable, resetModal, showNewTable, rows, excelColumns, loadingTable }) => {
    return (
        <>
            <Box component="div" sx={{ cursor: 'pointer', display: 'flex', gap: '15px', alignItems: 'center', position: 'absolute', top: { xs: '10px', sm: '30px' }, left: { xs: '10px', sm: showNewTable && loadingTable === false ? '30px' : '35px' } }}>
                <div onClick={() => setShowNewTable(false)}>
                    <ArrowBackIosNew
                        sx={{
                            color: themeColors.gray40,
                            display: showNewTable && loadingTable === false ? 'block' : 'none',
                        }}
                    />
                </div>
                <div onClick={() => setShowNewTable(true)}>
                    <ArrowForwardIosIcon
                        sx={{
                            color: themeColors.gray40,
                            display: showNewTable === false && rows.length > 0 && excelColumns.length > 0 ? 'block' : 'none',
                        }}
                    />
                </div>
            </Box>
            <div onClick={resetModal} style={{ cursor: 'pointer' }}>
                <CloseOutlined
                    sx={{
                        color: themeColors.gray40,
                        display: 'block',
                        position: 'absolute',
                        top: { xs: '10px', sm: '30px' },
                        right: { xs: '10px', sm: '30px' },
                    }}
                />
            </div>
        </>
    )
}

export default ModeGraphicModalHeader